import { jsx } from 'react/jsx-runtime';
import { SelectListProvider } from './SelectList.Context/SelectList.Context.es.js';
import { SelectListCore } from './SelectList.Core/SelectList.Core.es.js';
import { SelectListItem } from './SelectList.Item/SelectList.Item.es.js';
import { SelectListLoading } from './SelectList.Loading/SelectList.Loading.es.js';
import { SelectListNoItems } from './SelectList.NoItems/SelectList.NoItems.es.js';
import { SelectListNoResults } from './SelectList.NoResults/SelectList.NoResults.es.js';

const SelectList = ({ selected, ...props })=>{
    return jsx(SelectListProvider, {
        selected: selected,
        children: jsx(SelectListCore, {
            ...props
        })
    });
};
SelectList.Item = SelectListItem;
SelectList.Loading = SelectListLoading;
SelectList.NoItems = SelectListNoItems;
SelectList.NoResults = SelectListNoResults;
SelectList.displayName = 'SelectList';

export { SelectList };
//# sourceMappingURL=SelectList.es.js.map
